import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import "select2"

export default class extends Controller {
  static targets = ["dropdown", "viewReport"]

  connect() {
    this.casesLoaded = false
    if (!$(this.dropdownTarget).hasClass("select2-hidden-accessible")) {
      $(this.dropdownTarget).select2({
        dropdownParent: $('#selectCaseOrScriptModal'),
        width: '100%',
        placeholder: "Select Case/Script",
        data: [
          {
            id: '0',
            text: 'Loading cases/scripts...',
            selected: false,
            disabled: true
          }
        ]
      })
    }

    this.updateLink()
    $(this.dropdownTarget).on('change', this.updateLink.bind(this))
  }

  disconnect() {
    if ($(this.dropdownTarget).hasClass("select2-hidden-accessible")) {
      $(this.dropdownTarget).select2('destroy')
    }
  }

  loadCasesAndScripts() {
    if (this.casesLoaded) return;
    fetch("/report_dashboard/cases_and_scripts.json")
      .then(response => {
        if (!response.ok) throw new Error("Failed to load cases/scripts");
        return response.json();
      })
      .then(items => {
        this.dropdownTarget.innerHTML = '';

        if (Array.isArray(items) && items.length > 0) {
          // Add default option
          this.dropdownTarget.innerHTML = '<option value="">All Cases/Scripts</option>';

          // Append case/script options
          items.forEach(item => {
            const option = document.createElement("option");
            option.value = item.id;
            option.textContent = item.name;
            option.setAttribute("data-name", item.name);
            this.dropdownTarget.appendChild(option);
          });

          this.initCaseScriptSelect2("Select Case/Script");
        } else {
          const message = "No results found – create a course to view reports";

          // Add disabled message option
          const option = document.createElement("option");
          option.value = "";
          option.textContent = message;
          option.disabled = true;
          option.selected = true;
          this.dropdownTarget.appendChild(option);

          this.initCaseScriptSelect2("Select Case/Script", message);
        }

        this.casesLoaded = true;
      })
      .catch(() => {
        this.dropdownTarget.innerHTML = '<option value="">Unable to load cases/scripts</option>';
        this.initCaseScriptSelect2("Unable to load cases/scripts");
        this.casesLoaded = false;
      });
  }

  initCaseScriptSelect2(placeholder, noResultsMessage = null) {
    $(this.dropdownTarget).select2({
      dropdownParent: $('#selectCaseOrScriptModal'),
      width: '100%',
      placeholder: placeholder,
      language: noResultsMessage
        ? { noResults: () => noResultsMessage }
        : {}
    });

    $(this.dropdownTarget).val("").trigger("change");
  }

  updateLink() {
    const dropdown = this.dropdownTarget
    const viewReport = this.viewReportTarget
    const selected = dropdown.options[dropdown.selectedIndex]
    const caseId = selected.value

    if (caseId) {
      const url = `/reports/case_report/${caseId}`
      viewReport.href = url
      viewReport.onclick = (e) => {
        $('#selectCaseOrScriptModal').modal('hide')
      }
      viewReport.classList.remove('disabled')
    } else {
      viewReport.href = "#"
      viewReport.onclick = function() { return false }
      viewReport.classList.add('disabled')
    }
  }
}
